import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class VersionControllerService {
  constructor(private http: HttpClient) {
  }
  getVersion(): Observable<any> {
    return this.http.get(`/version`, {responseType: 'text'});
  }
}
